import { InjectionToken } from '@angular/core';

export const DEV_FLAGS = new InjectionToken<DevFlagsMap>('DevFlagsMap');

export enum DevFlag {
  DisableZiggeo = 'disable-ziggeo',
  Referrals = 'referrals', // This flag should be migrated to pricing features after release
  EventDebug = 'debug_event_tracking',
  Hotjar = 'hotjar',
  PP24Enabled = 'pp24_enabled',
  TellentSas = 'tellent_sas',
  LinkedInRSC = 'linkedin_rsc',
  Onboarding = 'onboarding',
  ViewsCandidates = 'views_candidates',
  ReportsExportImprovements = 'reports_export_improvements',
  ReportsExportImprovementsDebug = 'export_improvements_debug',
  NewDashboard = 'new_dashboard',
  ProsemirrorInJobEditor = 'prosemirror_in_job_editor',
  PromoteKiwiHR = 'promote_kiwihr',
  MergingImprovements = 'merging_improvements',
  EmailSyncingProtection = 'email_syncing_protection',
  EvaluationInsights = 'evaluation_insights',
  TellentSuiteMigrated = 'tellent_suite_migrated',
  OfferLetters = 'offer_letters',
  AaImprovements = 'aa_improvements',
  WorkflowAutomations = 'new_aa_wizard',
  RecentNotes = 'recent_notes',
  UnifiedDepartments = 'unified_departments',
  AppShell = 'app_shell',
  MailboxEmailValidation = 'mailbox_email_validation',
  OneDomainATS = 'one_domain_ats',
  ApplyWithWhatsapp = 'apply_with_whatsapp',
  ManageFeaturesPromotion = 'manage_features_promotion',
  WhatsappFunnelBridge = 'whatsapp_funnelbridge', // Some customers have Funnelbridge integration and enable WhatsApp in a different way
  UploadPrivateFiles = 'upload_private_files',
  ForceNewOffersEndpointFlag = 'force_new_offers_endpoint_flag',
  CandidateSalutationFields = 'candidate_salutation_fields',
  AiCandidateMatching = 'ai_candidate_matching',
  WorkflowAutomationImprovements = 'workflow_automation_improvements',
  EventCustomName = 'event_custom_name',
}

export type DevFlagsMap = Record<DevFlag, boolean>;
